import { IStackTokens, PrimaryButton, Stack } from "@fluentui/react";
import { BipUserList } from "admin/bipuser/components";
import { Module, UserType } from "authentication/auth.types";
import { AuthStateContext } from "authentication/useAuthContext";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Card, CardBody } from "reactstrap";
import { ErrorDialog, Loading, ModalControl, useModal } from "shared/components";
import { Confirmation } from "shared/components/Confirmation/Confirmation";
import { useError } from "shared/hooks";
import { IBipUsersProps, useBipUser } from ".";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
	PaginationProvider,
	PaginationTotalStandalone,
	PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
const verticalGapStackTokens: IStackTokens = {
	childrenGap: 15,
	padding: 10,
};

export const BipUsers: React.FC<IBipUsersProps> = (props) => {
	const { onGetDetail, onCreate } = props;
	const { errorstate, onErrorClose, onError } = useError();
	const authState = useContext(AuthStateContext);
	const { user } = authState;
	const { userRolePermissions } = user;
	const { state, onDelete } = useBipUser("LIST", { bipId: undefined }, onError);
	const [confirmation, setConfirmation] = useState(true);
	const { modalState, onCloseModal, onShowModal } = useModal();
	const { SearchBar } = Search;
	const columns = [
		{
			dataField: "firstName",
			text: "Name",
			formatter: (cellContent: any, row: any) => {
				return (
					<>
						{row.firstName} {row.lastName}
					</>
				);
			},
		},
		{
			dataField: "emailAddress",
			text: "Email",
		},
		{
			dataField: "price",
			text: "Status",
			formatter: (cellContent: any, row: any) => {
				return <>{row.userStatus === 1 ? "Active" : "Inactive"}</>;
			},
		},
		{
			dataField: "button",
			isDummyField: true,
			text: "",
			formatter: (cellContent: any, row: any) => {
				return (
					<>
						<button
							className="btn btn-outline-primary"
							onClick={() => onGetDetail && onGetDetail(row.bipId)}
						>
							View Detail
						</button>
						{userRolePermissions.some((c) => c.moduleId === Module.BIP && c.delete) && (
							<button
								className="btn btn-outline-danger ml-2"
								onClick={() =>
									onShowModal(
										"Are you sure?",
										`Delete ${row.firstName} ${row.lastName}`,
										row.bipId,
									)
								}
							>
								Delete
							</button>
						)}
					</>
				);
			},
		},
	];

	if (state.isBusy) {
		return <Loading />;
	}

	const options = {
		custom: true,
		totalSize: state.users.length,
	};
	// const deleteConfirmation = (id: any) => {
	// 	console.log("Confirmed", id);
	// 	setConfirmation(false);
	// };
	const onDeleteConfirm = () => {
		onDelete(parseInt(modalState.data, 10));
		onCloseModal();
	};

	return (
		<>
			{/* <Confirmation
				onSubmit={deleteConfirmation}
				show={confirmation}
				message="Do you really want to delete?"
			/> */}
			<div className="row">
				<div className="col-md-12">
					<div className="float-right">
						<button className="btn btn-primary mb-4" onClick={onCreate}>
							<i className="fas fa-user-plus"></i> New Coach
						</button>
					</div>
				</div>
			</div>
			<Breadcrumb tag="nav" listTag="div">
				<BreadcrumbItem
					tag={Link}
					to={`/${user.userType === UserType.BIP ? "bip" : "admin"}/home`}
				>
					Dashboard
				</BreadcrumbItem>
				<BreadcrumbItem active>Coach</BreadcrumbItem>
			</Breadcrumb>
			<ModalControl
				modalState={modalState}
				onCloseModal={onCloseModal}
				onConfirm={onDeleteConfirm}
			/>
			<ErrorDialog
				errorMessage={errorstate.errorMessage}
				show={errorstate.visible}
				onClose={onErrorClose}
			/>
			<div className="row">
				<div className="col-md-12">
					<Card>
						<ToolkitProvider keyField="id" data={state.users} columns={columns} search>
							{(props: any) => (
								<div>
									<div className="d-flex justify-content-end">
										<div className="col-md-4">
											<div className="float-right pt-2">
												<SearchBar {...props.searchProps} />
											</div>
										</div>
									</div>
									<PaginationProvider pagination={paginationFactory(options)}>
										{({ paginationProps, paginationTableProps }: any) => (
											<>
												<BootstrapTable
													keyField="id"
													headerClasses="thead-light"
													bordered={false}
													columns={columns}
													noDataIndication="No records found!"
													{...props.baseProps}
													{...paginationTableProps}
												/>
												<div className="d-flex justify-content-between">
													<div className="col-md-4">
														<PaginationTotalStandalone
															{...paginationProps}
														/>
													</div>
													<div className="col-md-4">
														<div className="float-right">
															<PaginationListStandalone
																{...paginationProps}
															/>
														</div>
													</div>
												</div>
											</>
										)}
									</PaginationProvider>
								</div>
							)}
						</ToolkitProvider>
						{/* <table className="table">
							<thead className="thead-light">
								<tr>
									<th>Name</th>
									<th>Email</th>
									<th>Status</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{state.users.map((item) => {
									return (
										<tr>
											<td>{`${item.firstName} ${item.lastName}`}</td>
											<td>{item.emailAddress}</td>
											<td>{item.userStatus === 1 ? "Active" : "Inactive"}</td>
											<td>
												<button
													className="btn btn-outline-primary"
													onClick={() =>
														onGetDetail && onGetDetail(item.bipId)
													}
												>
													View Detail
												</button>
												{userRolePermissions.some(
													(c) => c.moduleId === Module.BIP && c.delete
												) && (
													<button
														className="btn btn-outline-danger ml-2"
														onClick={() => onDelete(item.bipId)}
														// onClick={() =>
														// 	deleteConfirmation(item.bipId)
														// }
													>
														Delete
													</button>
												)}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table> */}
					</Card>
				</div>
			</div>
		</>
	);

	return (
		<Stack tokens={verticalGapStackTokens}>
			<Stack.Item align="end">
				<PrimaryButton text="Add User" onClick={onCreate} />
			</Stack.Item>
			<Stack>
				<ErrorDialog
					errorMessage={errorstate.errorMessage}
					show={errorstate.visible}
					onClose={onErrorClose}
				/>
			</Stack>
			<Stack.Item>
				<BipUserList users={state.users} onGetDetail={onGetDetail} />
			</Stack.Item>
		</Stack>
	);
};
